<template>
    <div v-show="visible" v-on-clickaway="hide" class="help-window">
        <Transition name="expand">
            <div>
                <div class="help-header">
                    <h3>Help</h3>
                    <span class="close-icon" @click.prevent="hide">
                        <a><i class="icon-close"></i></a>
                    </span>
                </div>
                <div class="help-body" v-html="helpContent"></div>
            </div>
        </Transition>
    </div>
</template>

<script type="text/babel">
import { mixin as clickaway } from 'vue-clickaway';
import { resourceCheckCustomHelp, resourceGetCustomHelp, resourceGetDefaultHelp } from '../../api/resources';
import { getCancelToken } from '../../api';
import { mapMutations } from 'vuex';

export default {
    mixins: [clickaway],

    props: {
        currentPage: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            visible: false,
            helpContent: '',
            cache: {},
            cancelToken: undefined,
        };
    },

    watch: {
        currentPage(page) {
            if (page) {
                this.show(page);
            } else {
                this.hide();
            }
        },
        $route() {
            this.hide();
        },
    },
    mounted() {
        this.$root.$on('hideHelp', this.hide);
    },
    methods: {
        ...mapMutations({
            unsetHelp: 'navigation/UNSET_HELP',
        }),

        hide() {
            if (this.cancelToken) {
                this.cancelToken.cancel();
            }
            if (this.visible) {
                this.visible = false;
                this.helpContent = '';
                this.unsetHelp();
            }
        },

        show(page) {
            this.cancelToken = getCancelToken();
            if (this.cache.hasOwnProperty(page)) {
                this.helpContent = this.cache[page];
            } else {
                this.helpContent = '<p>' + this.$t('help.loading') + '</p>';
                this.loadHelp(page)
                    .then(({ data }) => {
                        this.helpContent = data;
                        this.cache[page] = data;
                    })
                    .catch(() => {
                        this.helpContent = '<p>' + this.$t('help.notFound') + '</p>';
                    });
            }
            this.visible = true;
        },

        loadHelp(page) {
            return resourceCheckCustomHelp({
                cancelToken: this.cancelToken.token,
            }).then(
                // If custom help directory exists and is not empty
                () =>
                    resourceGetCustomHelp({
                        page: page,
                        cancelToken: this.cancelToken.token,
                    }),

                // If custom help directory does not exist or is empty
                () =>
                    resourceGetDefaultHelp({
                        page: page,
                        cancelToken: this.cancelToken.token,
                    })
            );
        },
    },
};
</script>
